import _ from 'underscore';
import cheet from 'cheet.js';
const _require = require('./team.json'),
  availableAsteroids = _require.availableAsteroids;
const Crafty = require('./crafty-min');

/**
 *  Run the game. Game logic pulled from:
 *  https://github.com/craftyjs/demos/tree/master/asteroids
 */
const runGame = () => {
  // create div
  const div = global.document.createElement('div');
  div.setAttribute('id', 'cr-stage');
  const body = global.document.getElementsByTagName('body')[0];
  // put the div at the top of the list
  body.insertBefore(div, body.firstChild);
  Crafty.init();
  let burnDown = availableAsteroids.slice(0);

  // preload the needed assets - for some reason this is also needed to prime `main`
  const assets = {
    images: ['img/about/bg.jpg']
  };
  Crafty.load(assets, () => {
    Crafty.audio.play('Blaster');

    // start the main scene when loaded
    Crafty.scene('main');
  }, e => {
    // uh oh, error loading
    /* eslint-disable-next-line no-console */
    console.log('fail', e);
  });
  Crafty.audio.add('Blaster', ['img/about/laser.wav']);
  Crafty.scene('main', () => {
    Crafty.background('url("img/about/bg.jpg")');

    // keep a count of asteroids
    let asteroidCount;
    let lastCount;

    // function to fill the screen with asteroids by a random amount
    const initRocks = (lower, upper) => {
      const rocks = Crafty.math.randomInt(lower, upper);
      asteroidCount = rocks;
      lastCount = rocks;
      for (let i = 0; i < rocks; i += 1) {
        Crafty.e('2D, DOM, big, Collision, asteroid');
      }
    };
    if (!burnDown.length) {
      burnDown = availableAsteroids.slice(0);
    }
    const currentAsteroidIndex = _.random(burnDown.length - 1);
    const currentAsteroid = burnDown[currentAsteroidIndex];
    burnDown.splice(currentAsteroidIndex, 1);
    Crafty.sprite(64, currentAsteroid.image, {
      ship: [0, 0],
      big: [1, 0],
      medium: [2, 0],
      small: [3, 0]
    });
    // current asteroid
    Crafty.e('2D, DOM, Text').text(currentAsteroid.name).textFont({
      size: '20px',
      weight: 'bold'
    }).attr({
      x: 15,
      y: 15,
      w: 200,
      h: 50
    }).css({
      color: '#fff'
    });

    // exit text
    Crafty.e('2D, DOM, Mouse, Text').text('(x) Exit').textFont({
      size: '20px'
    }).attr({
      x: Crafty.viewport.width - 100,
      y: 20,
      w: 200,
      h: 50
    }).css({
      color: '#fff'
    }).bind('Click', MouseEvent => {
      /* eslint-disable-next-line no-alert */
      global.alert('Thanks for playing!', MouseEvent);
      global.location.reload();
    });

    // score display
    const score = Crafty.e('2D, DOM, Text').text('Score: 0').textFont({
      size: '20px',
      weight: 'bold'
    }).attr({
      x: Crafty.viewport.width - 150,
      y: Crafty.viewport.height - 75,
      w: 200,
      h: 50
    }).css({
      color: '#fff'
    });

    // player entity
    const player = Crafty.e('2D, Canvas, ship, Controls, Collision').attr({
      move: {
        left: false,
        right: false,
        up: false,
        down: false
      },
      xspeed: 0,
      yspeed: 0,
      decay: 0.9,
      x: Crafty.viewport.width / 2,
      y: Crafty.viewport.height / 2,
      score: 0
    }).origin('center').bind('KeyDown', e => {
      // on keydown, set the move booleans
      if (e.key === Crafty.keys.RIGHT_ARROW) {
        player.move.right = true;
      } else if (e.key === Crafty.keys.LEFT_ARROW) {
        player.move.left = true;
      } else if (e.key === Crafty.keys.UP_ARROW) {
        player.move.up = true;
      } else if (e.key === Crafty.keys.SPACE) {
        Crafty.audio.play('Blaster');
        // create a bullet entity
        const bullet = Crafty.e('2D, DOM, Color, bullet').attr({
          x: player.x + 25,
          y: player.y + 35,
          w: 2,
          h: 5,
          rotation: player.rotation,
          xspeed: 20 * Math.sin(player.rotation / 57.3),
          yspeed: 20 * Math.cos(player.rotation / 57.3)
        }).color('rgb(198, 180, 74)').bind('EnterFrame', () => {
          bullet.x += bullet.xspeed;
          bullet.y -= bullet.yspeed;

          // destroy if it goes out of bounds
          if (bullet.x > Crafty.viewport.width || bullet.x < 0 || bullet.y > Crafty.viewport.height || bullet.y < 0) {
            bullet.destroy();
          }
        });
      }
    }).bind('KeyUp', e => {
      // on key up, set the move booleans to false
      if (e.key === Crafty.keys.RIGHT_ARROW) {
        player.move.right = false;
      } else if (e.key === Crafty.keys.LEFT_ARROW) {
        player.move.left = false;
      } else if (e.key === Crafty.keys.UP_ARROW) {
        player.move.up = false;
      }
    }).bind('EnterFrame', () => {
      if (player.move.right) {
        player.rotation += 5;
      }
      if (player.move.left) {
        player.rotation -= 5;
      }

      // acceleration and movement vector
      const vx = Math.sin(player.rotation * Math.PI / 180) * 0.3;
      const vy = Math.cos(player.rotation * Math.PI / 180) * 0.3;

      // if the move up is true, increment the y/xspeeds
      if (player.move.up) {
        player.yspeed -= vy;
        player.xspeed += vx;
      } else {
        // if released, slow down the ship
        player.xspeed *= player.decay;
        player.yspeed *= player.decay;
      }

      // move the ship by the x and y speeds or movement vector
      player.x += player.xspeed;
      player.y += player.yspeed;

      // if ship goes out of bounds, put him back
      if (player.x > Crafty.viewport.width) {
        player.x = -64;
      }
      if (player.x < -64) {
        player.x = Crafty.viewport.width;
      }
      if (player.y > Crafty.viewport.height) {
        player.y = -64;
      }
      if (player.y < -64) {
        player.y = Crafty.viewport.height;
      }

      // if all asteroids are gone, start again with more
      if (asteroidCount <= 0) {
        initRocks(lastCount, lastCount * 2);
      }
    }).collision().onHit('asteroid', () => {
      // if player gets hit, restart the game
      Crafty.scene('main');
    });

    // Asteroid component
    // Note (jrw): kept es5 function since "this" binding gets confusing and difficult with
    //  the component instance created by Crafty.c
    /* eslint-disable object-shorthand, func-names */
    const asteroid = {
      init: function init() {
        this.origin('center');
        this.attr({
          // give it random positions, rotation and speed
          x: Crafty.math.randomInt(0, Crafty.viewport.width),
          y: Crafty.math.randomInt(0, Crafty.viewport.height),
          xspeed: Crafty.math.randomInt(1, 5),
          yspeed: Crafty.math.randomInt(1, 5),
          rspeed: Crafty.math.randomInt(-5, 5)
        }).bind('EnterFrame', function () {
          this.x += this.xspeed;
          this.y += this.yspeed;
          this.rotation += this.rspeed;
          if (this.x > Crafty.viewport.width) {
            this.x = -64;
          }
          if (this.x < -64) {
            this.x = Crafty.viewport.width;
          }
          if (this.y > Crafty.viewport.height) {
            this.y = -64;
          }
          if (this.y < -64) {
            this.y = Crafty.viewport.height;
          }
        }).collision().onHit('bullet', function (e) {
          // if hit by a bullet increment the score
          player.score += 5;
          score.text("Score: ".concat(player.score));
          e[0].obj.destroy(); // destroy the bullet

          let size;
          // decide what size to make the asteroid
          if (this.has('big')) {
            this.removeComponent('big').addComponent('medium');
            size = 'medium';
          } else if (this.has('medium')) {
            this.removeComponent('medium').addComponent('small');
            size = 'small';
          } else if (this.has('small')) {
            // if the lowest size, delete self
            asteroidCount -= 1;
            this.destroy();
            return;
          }
          const oldxspeed = this.xspeed;
          this.xspeed = -this.yspeed;
          this.yspeed = oldxspeed;
          asteroidCount += 1;
          // split into two asteroids by creating another asteroid
          Crafty.e("2D, DOM, ".concat(size, ", Collision, asteroid")).attr({
            x: this.x,
            y: this.y
          });
        });
      }
    };
    Crafty.c('asteroid', asteroid);

    // first level has between 1 and 10 asteroids
    initRocks(1, 10);
  });
};
cheet('↑ ↑ a b o u t', () => {
  runGame();
});